<template>
  <require from="framework/html_behaviors/af-movable"></require>
  <require from="framework/aurelia_dialogs/dialog-styles.css"></require>
  <require from="controls/as-form-richtexteditor"></require>
  <require from="controls/bs-form-input"></require>

  <style>
    .ck-editor__editable_inline {
      min-height: 40vh;
    }

    .as-form-richtexteditor {
      min-height: 40vh;
    }
  </style>

  <ux-dialog class="af-dialog users-email-dialog" af-movable.bind="header">
    <ux-dialog-header ref="header">
      Email message
    </ux-dialog-header>
    <ux-dialog-body>
      <div class="af-dialog__main">
        <form class="container-fluid">
          <div class="form-row">
            <div class="col">
              <bs-form-input type="text" label="From" placeholder="Email sender" value.bind="from" disabled="true"></bs-form-input>
            </div>
          </div>
          <div class="form-row">
            <div class="col">
              <bs-form-input type="text" label="Subject" placeholder="Email subject" value.bind="model.subject & validate" maxlength="988" attach-focus="true"></bs-form-input>
            </div>
          </div>
          <div class="form-row">
            <div class="col">
              <as-form-richtexteditor label="Message" placeholder="Email message" value.bind="model.message & validate"></as-form-richtexteditor>
            </div>
          </div>
        </form>
      </div>
    </ux-dialog-body>
    <ux-dialog-footer>
      <button type="button" class="btn-primary" click.delegate="ok()"><i class="fas fa-paper-plane mr-1"></i>Send</button>
      <button type="button" click.delegate="dialogController.cancel()">Cancel</button>
    </ux-dialog-footer>
  </ux-dialog>
</template>
